
<template>
  <div >
    <el-carousel trigger="click"  :height="autoHeight">
      <el-carousel-item v-for="item in indata.children" :key="item">
       <a :href="item.url" target="_blank">
      
         <el-image
      style="width: 100%;height: 100%"
      :src="item.image "
      fit="cover"></el-image></a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style scoped src="../../public/css/cloudApp.css">
/* @import "../../public/css/cloudApp.css"; */
</style>

<script>
export default {
  name: "Templates12",
  props: {
    indata: Array,
  },
  computed: {
  //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    }
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
